import { Checkbox } from "@mui/material";
import { ArrowRight, ChevronLeft, X } from "lucide-react";
import { Button } from "@components/ui/button";
import { useNavigate } from "react-router";
import { ContactDeptData } from "@assets/mocks/filterData";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@redux/store";
import { saveFiltersState, updateHierarchy, updateSearchOptions } from "@redux/slices/filter";

interface Props {
  handleClose: () => void;
}

const DepartmentAndHierarchy: React.FC<Props> = ({ handleClose }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contactFilters = useSelector(
    (state: RootState) => state.filter.contactFilters
  );
  const searchOptions = contactFilters.departmentHierarchy?.searchOptions || {};
  const hierarchy = contactFilters.departmentHierarchy?.hierarchy || {};

  const data=useSelector((state: RootState)=>state.filter);

  const handleCheckboxChange = (
    type: "searchOptions" | "hierarchy",
    key: string
  ) => {
    console.log(type, key);

    const updatedOptions =
      type === "searchOptions"
        ? { ...searchOptions, [key]: !searchOptions[key] }
        : { ...hierarchy, [key]: !hierarchy[key] };

    if (type === "searchOptions") {
      dispatch(updateSearchOptions(updatedOptions));
      console.log(type);
    } else {
      dispatch(updateHierarchy(updatedOptions));
    }
  };

  return (
    <div className="flex flex-col justify-between h-full p-8">
      <div>
        <div className="flex justify-between items-center mb-5">
          <h4 className="text-xl font-bold flex items-center -ms-2">
            <ChevronLeft
              size={22}
              className="me-3 cursor-pointer"
              onClick={() => navigate(-1)}
            />
            Department & Hierarchy
          </h4>
          <X onClick={handleClose} className="cursor-pointer" />
        </div>
        <div className="flex gap-4">
          <div className="bg-white rounded-lg w-2/3 px-6 py-4 h-80 overflow-y-scroll">
            <h4 className="text-lg font-bold flex items-center mb-4">
              Search for Contacts
            </h4>
            {ContactDeptData.map((val, index) => (
              <div
                key={index}
                className={`flex items-end justify-between text-sm font-medium cursor-pointer text-[#71717A] ${
                  index > 0 && "pt-3"
                } ${
                  index < 8 &&
                  "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
                }`}
                onClick={() => handleCheckboxChange("searchOptions", val)}
              >
                <h6 className="ms-1">{val}</h6>
                <Checkbox  sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }} checked={!!searchOptions[val]} />
              </div>
            ))}
          </div>
          <div className="flex flex-col justify-between w-1/3">
            <div className="bg-white rounded-lg px-6 py-4">
              <h4 className="text-lg font-bold flex items-center mb-4">
                Hierarchy level:
              </h4>
              {["Top Management", "Middle Management", "Employee"].map(
                (level, index) => (
                  <div
                    key={index}
                    className={`flex justify-between items-end text-sm font-medium ${
                      index > 0 && "pt-3"
                    } ${
                      index < 2 &&
                      "border-[1px] border-x-0 border-t-0 border-[#DBDBDB] pb-1"
                    } cursor-pointer text-[#71717A]`}
                    onClick={() => handleCheckboxChange("hierarchy", level)}
                  >
                    <h6 className="ms-1">{level}</h6>
                    <Checkbox
                      sx={{
                        color: '#1CB5AF', // Unchecked color
                        '&.Mui-checked': {
                          color: '#1CB5AF', // Checked color
                        },
                        padding:0
                      }}
                      checked={!!hierarchy[level]}
                    />
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={() => navigate(-1)} className="bg-[#1CB5AF]">Save</Button>
      </div>
    </div>
  );
};

export default DepartmentAndHierarchy;
